"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=(t,e)=>{try{t.validateSync(e)}catch(r){return{[r.path]:r.message}}return{}};exports.getFormInitialErrors=a;
